export enum PayerType {
  INDIVIDUAL = 'individual_payer',
  ADMIN = 'admin_payer',
}
